<template>
    <div class="bng-slots-filter">
        <div class="columns is-gapless">
            <div class="filter column is-narrow" :class="{'disabled': !showMenu}">
                <div v-if="showMenu" class="columns is-gapless">
                    <a
                        v-for="c in slotCategories"
                        :key="c"
                        @click="category = c; filter();"
                        :class="{'active': c == category}"
                        class="column is-uppercase"
                    >
                        <span>{{`components.common.slots-filter.slotCategories.${c}` | translate}}</span>
                    </a>
                </div>
            </div>
            <div class="search column">
                <label :class="{'active': showSearch}">
                    <input
                        class="input is-rounded"
                        type="text"
                        :placeholder="'components.common.slots-filter.seach placeholder' | translate"
                        v-model.trim="searchText"
                        @input="filter()"
                    />
                    <div class="button is-rounded is-dark" @click="showSearch = !showSearch">
                        <span class="icon has-text-warning">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                </label>
            </div>
            <div class="sort">
                <div class="is-centered buttons has-addons">
                    <a
                        class="button is-warning is-small is-uppercase"
                        v-for="s in sortOptions"
                        :key="s"
                        :class="s == sort ? 'is-selected': 'is-outlined'"
                        @click="sort = s; filter();"
                    >{{`components.common.slots-filter.sortOptions.${s}` | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'slots-filter',
    props: {
        onFilter: {
            type: Function,
            required: true
        },
        showMenu: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            slotCategories: [
                'all',
                'new',
                'popular',
                'nonslot'
            ],
            sortOptions: [
                'popularity',
                'alphabetically'
            ],
            sort: 'popularity',
            category: 'all',
            searchText: null,
            showSearch: false
        };
    },
    computed: {
        
    },
    methods: {
        filter() {
            this.onFilter(this.category, this.sort, this.searchText);
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/slots-filter/slots-filter.vue